import React, { useCallback, useRef } from 'react'
import { InView } from 'react-intersection-observer'
import styled from 'styled-components'
import { rem } from 'polished'
import config from 'constants/config'
import Pane from 'components/Common/Pane'
import TrustPilotSection from 'components/Common/TrustReviewSection/TrustPilotSection'
import { useDeferredAnalyticsOptimizely } from 'lib/optimizely/useDeferredAnalyticsOptimizely'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'

const TrustPilotContainer = styled(Pane)`
  box-shadow: ${props => props.theme.shadow.flat.small};
  padding: ${rem(20)} ${rem(24)};
`

const CarouselWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  contain: inline-size;
`

interface Props {
  className?: string
}

function OfferPageTrustPilot({ className }: Props) {
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const startedLoggedInRef = useRef(isLoggedIn)
  const { variation, triggerAnalytics } = useDeferredAnalyticsOptimizely(
    OptimizelyExperiments.croTrustpilotReviewFeedInOfferPage,
  )
  const experimentDecision = typeof variation === 'string' ? variation : null
  const isExperimentEnabled = getOptimizelyEnabledDecision(experimentDecision)
  const isEligible = !startedLoggedInRef.current
  const shouldShow = isEligible && isExperimentEnabled

  const handleInView = useCallback((inView: boolean) => {
    if (inView && shouldShow) {
      triggerAnalytics()
    }
  }, [shouldShow, triggerAnalytics])

  if (config.BRAND !== 'luxuryescapes') {
    return null
  }

  if (!shouldShow) {
    return null
  }

  return (
    <InView onChange={handleInView} triggerOnce>
      <TrustPilotContainer className={className}>
        <CarouselWrapper>
          <TrustPilotSection />
        </CarouselWrapper>
      </TrustPilotContainer>
    </InView>
  )
}

export default React.memo(OfferPageTrustPilot)
